import { useI18n } from '@9troisquarts/wand';
import { Button, Card, Col, PageHeader, Row, Typography } from 'antd';
import React, { useState } from 'react';
import OfferForm from '../../../Admin/pages/offers/components/OfferForm';
import { OfferType } from '../../../types';

const PublicNewOffer = (props) => {
  const {
    token
  } = props.match.params;
  const { t } = useI18n();
  const [created, setCreated] = useState<boolean>(false);

  const onCompleted = () => {
    window.scroll(0, 0)
    setCreated(true);
  }

  if (created) {
    return (
      <Row style={{ justifyContent: 'center', marginTop: 45 }}>
        <Col xs={24} md={12} lg={12} xl={8}>
          <Card>
            <Typography.Title level={3}>
              {t('sentences.your_offer_has_been_created_title')}
            </Typography.Title>
            <Typography.Paragraph>
              {t('sentences.your_offer_has_been_created_description')}
            </Typography.Paragraph>
            <div style={{ textAlign: 'right' }}>
              <Button onClick={() => window.location.reload()}>
                {t('sentences.add_a_new_offer')}
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    )
  }
  return (
    <>
      <Row>
        <Col xs={24}>
          <PageHeader
            title={t('sentences.new_offer')}
          />
        </Col>
      </Row>
      <div className="inner-body">
        <Card>
          <OfferForm
            extraVariables={{ token }}
            onCompleted={onCompleted}
          />
        </Card>
      </div>
    </>
  )
}

export default PublicNewOffer;